import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MyOverlayRef } from '../services/overlay/myoverlay-ref';
import { tools } from '../services/tools';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { GoogleMapsModule } from '@angular/google-maps';

@Component({
    selector: 'app-gmaps-view',
    standalone : true,
    imports: [CommonModule, MatIconModule, GoogleMapsModule],
    templateUrl: './gmaps-view.component.html',
    styleUrls: ['./gmaps-view.component.scss']
})
export class GmapsViewComponent implements AfterViewInit {
  @ViewChild('gMapsCmp', { static: true }) public gMapsCmp: any;
  public gmapsMarkerName: any = '0';
  public gmapsLongitude: any = 0;
  public gmapsLatitude: any = 0;
  public marker: any;
  public mapOptions: google.maps.MapOptions | undefined;
  public loaded: boolean = false;
  public height: string = '400px';
  public width: string = '400px';
  public expenseAmount: string = '';
  public expenseDate: Date | undefined;

  constructor(
    private tools: tools,
    private ref?: MyOverlayRef,
  ) {
    this.setDatas(this.ref?.data);
  }
  ngAfterViewInit(): void {
    this.initialiseGmapsView();
  }

  ngOnChanges() {
    this.initialiseGmapsView();
  }

  public setDatas(data: any) {
    if (data != null) {
      this.gmapsLatitude = data.gmapsLatitude;
      this.gmapsLongitude = data.gmapsLongitude;
      this.gmapsMarkerName = data.markerName;
      this.width = data.width;
      this.height = data.height;
    }
  }

  private initialiseGmapsView() {
    this.mapOptions = {
      center: { lat: this.gmapsLatitude, lng: this.gmapsLongitude },
      zoom: 15,
    };
    this.marker = {
      draggable: false,
      title: this.gmapsMarkerName,
    };
    this.tools.delay(0).then(() => {
      this.loaded = true;
    });
  }

  public cancel() {
    if (this.ref) this.ref.close('cancel');
  }
}
